import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import Seo from '../components/Seo';

const Nosotros = () => {
  return (
    <div className="min-h-screen">
      <Seo
        title="Sobre Eclipse Tenis"
        description="Conoce Eclipse Tenis, tienda especializada en tenis para hombre y mujer, accesorios y envios a Colombia y Ecuador."
      />
      {/* Hero */}
      <div className="bg-gradient-to-br from-gray-900 to-gray-700 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Sobre Eclipse Tenis</h1>
          <p className="text-xl max-w-2xl mx-auto">
            Tu tienda de confianza para zapatillas de calidad en Colombia
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        {/* Nuestra Historia */}
        <section className="max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold mb-6 text-center">Nuestra Historia</h2>
          <div className="space-y-4 text-gray-700">
            <p>
              Eclipse Tenis es tu lugar ideal para encontrar las ultimas tendencias en calzado y
              moda. Desde 2019, nos hemos especializado en ofrecer una amplia variedad de tenis y
              zapatillas para caballero y dama.
            </p>
            <p>
              Ademas de nuestro catalogo de calzado deportivo, contamos con una seleccion de
              prendas y accesorios modernos, especialmente para dama.
            </p>
            <p>
              Llevamos el mejor estilo a tu puerta con envios rapidos y seguros a todo Colombia.
              Ofrecemos atencion personalizada de expertos y llegamos a todos los rincones del pais.
              Tambien realizamos envios seguros a Ecuador.
            </p>
            <p>
              Confia en nuestra experiencia para llevarte al siguiente nivel con calidad, moda y
              servicio profesional.
            </p>
          </div>
          <div className="mt-8 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
            <h3 className="text-lg font-semibold mb-4 text-gray-900">Ficha de la marca</h3>
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-gray-700">
              <div>
                <dt className="font-semibold text-gray-900">Nombre de la empresa</dt>
                <dd>Eclipse Tenis</dd>
              </div>
              <div>
                <dt className="font-semibold text-gray-900">Fundacion</dt>
                <dd>Desde 2019</dd>
              </div>
              <div>
                <dt className="font-semibold text-gray-900">Servicio</dt>
                <dd>Envios a todo Colombia y Ecuador</dd>
              </div>
              <div>
                <dt className="font-semibold text-gray-900">Enfoque</dt>
                <dd>Tenis para dama y caballero, accesorios modernos</dd>
              </div>
            </dl>
          </div>
        </section>

        {/* Valores */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold mb-8 text-center">Nuestros Valores</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card>
              <CardContent className="pt-6 text-center">
                <div className="text-4xl mb-4">⭐</div>
                <h3 className="text-xl font-bold mb-3">Calidad</h3>
                <p className="text-gray-600">
                  Solo trabajamos con las mejores marcas y productos que cumplen nuestros
                  estándares de calidad.
                </p>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="pt-6 text-center">
                <div className="text-4xl mb-4">🤝</div>
                <h3 className="text-xl font-bold mb-3">Confianza</h3>
                <p className="text-gray-600">
                  Transparencia en cada transacción y compromiso con la satisfacción de
                  nuestros clientes.
                </p>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="pt-6 text-center">
                <div className="text-4xl mb-4">🚀</div>
                <h3 className="text-xl font-bold mb-3">Innovación</h3>
                <p className="text-gray-600">
                  Mejoramos constantemente nuestra plataforma y servicios para ofrecerte la
                  mejor experiencia de compra.
                </p>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* Por qué elegirnos */}
        <section className="bg-gray-50 rounded-lg p-8 md:p-12">
          <h2 className="text-3xl font-bold mb-8 text-center">¿Por qué Elegirnos?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            <div className="flex gap-4">
              <div className="text-2xl">✅</div>
              <div>
                <h4 className="font-bold mb-2">Envíos a toda Colombia</h4>
                <p className="text-gray-600 text-sm">
                  Llegamos a cualquier ciudad con tiempos de entrega garantizados
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="text-2xl">✅</div>
              <div>
                <h4 className="font-bold mb-2">Facilidades de pago</h4>
                <p className="text-gray-600 text-sm">
                  Paga a cuotas con Sistecredito sin complicaciones
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="text-2xl">✅</div>
              <div>
                <h4 className="font-bold mb-2">Atención personalizada</h4>
                <p className="text-gray-600 text-sm">
                  Nuestro equipo está disponible para ayudarte vía WhatsApp y correo
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="text-2xl">✅</div>
              <div>
                <h4 className="font-bold mb-2">Garantía de calidad</h4>
                <p className="text-gray-600 text-sm">
                  Políticas claras de cambios y devoluciones
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Nosotros;
